import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import WorkscoreShell from '../../components/workscore/WorkscoreShell';
import { WORKSCORE_ASSESSMENTS } from '../../features/workscore/config';

export default function WorkscoreLandingPage() {
  const navigate = useNavigate();

  return (
    <WorkscoreShell>
      <div className="mx-auto max-w-7xl px-4 py-10 md:py-16">
        <div className="text-center">
          <h1 className="text-3xl md:text-5xl font-semibold tracking-tight">WorkScore Assessment Suite</h1>
          <p className="mt-3 text-white/65 max-w-2xl mx-auto">Behavioral decision intelligence for high-pressure, role-specific hiring.</p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {WORKSCORE_ASSESSMENTS.map((assessment, index) => (
            <motion.div
              key={assessment.slug}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.06 }}
              className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl p-6 transition-all hover:scale-[1.02]"
              style={{ boxShadow: `0 0 0 1px rgba(255,255,255,0.02), 0 0 28px ${assessment.color}22` }}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="text-3xl" aria-hidden="true">{assessment.icon}</div>
                <span className="text-xs px-2 py-1 rounded-full border border-white/15 bg-white/10">{assessment.questionsPerSection || 10} / section</span>
              </div>
              <h2 className="mt-4 text-xl font-medium">{assessment.title}</h2>
              <p className="mt-2 text-sm text-white/70 min-h-[52px]">{assessment.role}</p>

              <div className="mt-4 flex items-center gap-4 text-xs text-white/65">
                <span>{assessment.estimatedMinutes} min</span>
                <span>5 Sections</span>
                <span>Pool: 50 each</span>
              </div>

              <button
                type="button"
                onClick={() => navigate(`/assessment/${assessment.slug}/verify`)}
                className="mt-6 w-full rounded-xl px-4 py-3 font-semibold text-white"
                style={{ background: assessment.color }}
              >
                Start Assessment
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </WorkscoreShell>
  );
}
